import React from 'react';
import '../CSS/LoadingOverlay.css';

const LoadingOverlay = ({ message = 'Processing prediction data...' }) => {
  return (
    <div className="global-loading-overlay">
      <div className="global-loading-content">
        <div className="spinner-border global-spinner" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;